import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { PatchDeploymentConfigPayload, PatchDeploymentConfigResponse } from '@/api/device/types';
import { refreshCachedDevice } from '@/api/devices';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const patchDeploymentConfig = (props: PatchDeploymentConfigPayload): Promise<PatchDeploymentConfigResponse> => {
    const { spotterId, ...payload } = props;
    return axios.patch(`/user-rest/devices/${spotterId}/deployment-configuration`, payload);
};

type UsePatchDeploymentConfigOptions = {
    config?: MutationConfig<typeof patchDeploymentConfig>;
    data?: PatchDeploymentConfigPayload;
};

export const usePatchDeploymentConfig = ({ config }: UsePatchDeploymentConfigOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: patchDeploymentConfig,
        onSuccess: (data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Device deployment configuration updated', {
                spotterId: variables.spotterId,
                waterType: variables.waterType,
            });
        },
        onError: createErrorHandler('change deployment configuration'),
    });
};
